__turbopack_context__.v({
  "imageWrapper": "styles-module-scss-module__sIz7Ja__imageWrapper",
});
